module.exports = __webpack_public_path__ + "static/img/xjrzs.972e9b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01-shouye/xjrzs.jpg
// module id = u3BJ
// module chunks = 1